import React, { useEffect, useRef, useState } from 'react';
import Script from 'next/script';

import { StyledLink, StyledButton } from './LoginButton.styles';

let loginButtonIdCounter = 0;

const LoginButton = ({ cta, half, className }) => {
  const buttonRef = useRef(null);
  const [widgetId, setWidgetId] = useState(null);

  useEffect(() => {
    // Generate the widget container id only on the client to avoid hydration mismatches.
    setWidgetId(`bsport-login-${++loginButtonIdCounter}`);
  }, []);

  useEffect(() => {
    if (!widgetId || !buttonRef.current) return;

    const mountWidget = (config, repeat = 1) => {
      if (repeat > 50) return;

      if (!window.BsportWidget) {
        return setTimeout(() => {
          mountWidget(config, repeat + 1);
        }, 100 * repeat || 1);
      }

      window.BsportWidget.mount(config);
    };

    mountWidget({
      parentElement: widgetId,
      companyId: 2917,
      franchiseId: null,
      dialogMode: 1,
      widgetType: 'loginButton',
      showFab: false,
      fullScreenPopup: false,
      styles: undefined,
      config: {
        loginButton: {
          openMemberProfile: true,
        },
      },
    });

    const handleClick = () => {
      const hiddenButton = document.querySelector(`#${widgetId} .MuiButtonGroup-root button`);
      if (hiddenButton) {
        hiddenButton.click();
      }
    };

    const buttonElement = buttonRef.current;
    buttonElement.addEventListener('click', handleClick);

    return () => {
      buttonElement.removeEventListener('click', handleClick);
    };
  }, [widgetId]);

  return (
    <>
      <Script id="bsport-widget-cdn" src="https://cdn.bsport.io/scripts/widget.js" strategy="afterInteractive" />
      <StyledLink half={half} className={className}>
        <StyledButton ref={buttonRef}>{cta}</StyledButton>
        {widgetId && <div id={widgetId} style={{ display: 'none' }} />}
      </StyledLink>
    </>
  );
};

export default LoginButton;
